import React, { useEffect, useState } from "react";
import { Row, Col, Form, Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { CustomTextBox } from "Components/Shared/CustomTextBox";
import CommonService from "Services/CommonService";
import { CustomDropdown } from "Components/Shared/CustomDropdown";
import { forkJoin } from "rxjs";
import { IUniversityModel } from "Models/IUniversityModel";

type Props = {
    canCancel: any,
    isModelOpen: any,
    isEditId: any,
    isEdit: boolean
}

const UniversityMaster = ({ isEditId, isModelOpen, canCancel, isEdit }: Props) => {
    const [toast, SetToast] = useState(false);
    const [countryMaster, setCountryMaster] = useState<any>([]);
    const [stateMaster, setStateMaster] = useState<any>([]);
    const [cityMaster, setCityMaster] = useState<any>([]);
    const [zipCodeMaster, setZipCodeMaster] = useState<any>([]);
    const [isToggle, setToggle] = useState<boolean>(true);
    const [existingName, setExistingName] = useState("");
    const [isToggleModel, setIsToggleModel] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            address: '',
            countryId: '1',
            encryptedStateId: '',
            encryptedCityId: '',
            encryptedZipId: ''
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Location  Name").max(100, "Univerity name should not exceed 100 characters"),
            address: Yup.string().required("Please Enter Your Address").max(100, "Street Name should not exceed 100 characters"),
            // countryId: Yup.string().required("Please Select Your Country"),
            countryId: Yup.string(),
            encryptedStateId: Yup.string().required("Please Select Your State"),
            encryptedCityId: Yup.string().required("Please Select Your City"),
            encryptedZipId: Yup.string().required("Please Select Your ZipCode"),
        }),
        onSubmit: (values: any) => {
            if (isEdit) {
                submitUniversityCreation(values);
            }
            else {
                validateUniversityName(values);
            }
        }
    });

    const submitUniversityCreation = (values: IUniversityModel) => {
        setIsSubmitting(true);
        values.encryptedId = isEditId;
        values.displayName = values.name;
        values.enumName = values.name.replaceAll(' ', '_');
        values.active = isToggle;
        values.displayInList = true;
        CommonService.post("University", isEdit ? "UpdateUniversity" : "CreateUniversity", values).then(res => {
            if (res.status === 200) {
                canCancel();
            }
        }).finally(() => {
            setIsSubmitting(false);
        });;
    }
    const isCancel = () => {
        canCancel();
    }

    const getStateByCountryId = (countryid: any) => {
        CommonService.getWithQueryParam("Masters", "GetStateByCountryId", "countryId", countryid).then(res => {
            if (res.status === 200) {
                setStateMaster(res.data.responseData.stateList);
            }
        });
    }

    const getCityByStateId = (stateid: any) => {
        CommonService.getWithQueryParam("Masters", "GetCityByStateId", "stateId", stateid).then(res => {
            if (res.status === 200) {
                setCityMaster(res.data.responseData.cityList);
            }
        });
    }

    const getZipCodeByCityId = (encryptedCityId: any) => {
        CommonService.getWithQueryParam("Masters", "GetZipCodeByCityId", "cityId", encryptedCityId).then(res => {
            if (res.status === 200) {
                setZipCodeMaster(res.data.responseData.zipCodeList);
            }
        });
    }

    const validateUniversityName = (values: any) => {
        setIsSubmitting(true);
        CommonService.getWithQueryParam("University", "GetValidateUniversityName", "name", values.name).then(res => {
            if (res.status === 200) {
                if (res.data == "Already Exist UniversityName") {
                    return setExistingName(res.data);
                }
                else {
                    setExistingName("");
                    submitUniversityCreation(values);
                    canCancel();
                }
            }
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    const getUniversityById = () => {
        let restaurentId = localStorage.getItem("restaurentId");
        CommonService.getWithQueryParam("University", "GetUniversityById", "id", isEditId).then((res) => {
            if (res.status == 200) {
                validation.setFieldValue("name", res.data.responseData.name);
                validation.setFieldValue("address", res.data.responseData.address);
                validation.setFieldValue("countryId", res.data.responseData.countryId);
                getStateByCountryId(1);
                validation.setFieldValue("encryptedStateId", res.data.responseData.encryptedStateId);
                getCityByStateId(res.data.responseData?.encryptedStateId);
                validation.setFieldValue("encryptedCityId", res.data.responseData.encryptedCityId);
                getZipCodeByCityId(res.data.responseData?.encryptedCityId);
                validation.setFieldValue("encryptedZipId", res.data.responseData.encryptedZipId);
                if (res.data.responseData.active == false) {
                    setToggle(!isToggle);
                }
                else {
                    setToggle(isToggle)
                }
            }
        })
    }

    const onToggleChange = () => {
        if (isToggle) {
            confirmDelete(isEditId);
        } else {
            setIsDeleting(true);
            CommonService.postWithQueryParam("University", "ActivateUniversity", "encryptedId", isEditId).then(res => {
                if (res.status === 200) {
                    setToggle(true);
                }
            }).finally(() => {
                setIsDeleting(false);
            });
        }
    }

    const confirmDelete = (id) => {
        CommonService.deleteWithQueryParam("University", "RemoveUniversity", "id", id)
            .then(res => {
                if (res.data.responseMessage === "Deleted Successfully.") {
                    setToggle(false);
                }
                else {
                    setIsToggleModel(true);
                    setToggle(true);
                }
            })
            .catch(e => console.log(e));
    }


    const onClose = () => {
        setIsToggleModel(false);
    }

    const onNoClicked = () => {
        setIsToggleModel(false);
        setToggle(!isToggle);
    }

    const onYesClicked = () => {
        setIsDeleting(true);
        const updatedValues = {
            ...validation.values,
            id: isEditId,
            active: false,
            displayName: validation.values.name,
            enumName: validation.values.name.replaceAll(' ', '_'),
            displayInList: true
        };

        CommonService.post("University", "UpdateUniversity", updatedValues).then(res => {
            if (res.status === 200) {
                setIsToggleModel(false);
            }
        }).finally(() => {
            setIsDeleting(false);
        });
    }

    useEffect(() => {
        let country = CommonService.get("Masters", "GetCountryMaster");
        getStateByCountryId(1);

        forkJoin({ country }).subscribe((res: { country: any }) => {
            setCountryMaster(res.country.data.responseData.countryList);
        })
    }, []);

    useEffect(() => {
        if (isEdit) {
            getUniversityById();
        }
    }, [isEdit]);

    return (
        <React.Fragment>
            <div className="p-0 page-content">
                <p className="header-text-grid fw-bold fa-lg">{isEdit ? `${validation.values.name}` : 'Create Location'}</p>
                <div onClick={() => isCancel()} className="top-0 position-absolute m-3 btn-close end-0" ></div>
                <Form onSubmit={validation.handleSubmit}>
                    <Row>
                        <Col lg={12}>
                            <CustomTextBox id="name"
                                placeholder="Enter Location Name" name="name"
                                onChange={(e) => { validation.handleChange(e); setExistingName("") }}
                                onBlur={validation.handleBlur}
                                value={validation.values.name}
                                invalid={validation.touched.name && validation.errors.name ? true : false}
                                nameValidationError={existingName}
                                label="Location Name" error={validation.errors.name} isMandatory={true} />
                        </Col>
                        <Col lg={6}>
                            <CustomTextBox
                                name={`address`}
                                placeholder="Enter Street Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                id={`address`}
                                value={validation.values.address}
                                error={validation.touched.address && validation.errors.address ? validation.errors.address : undefined}
                                invalid={validation.touched.address && validation.errors.address ? true : false}
                                label="Street Name"
                                isMandatory={true}
                            />
                        </Col>
                        {/* <Col lg={6}><CustomDropdown label="Country" id="countryId" value={validation.values.countryId} data={countryMaster}
                            error={validation.errors.countryId} valueField="id" displayField='displayName' onChange={(e) => { validation.handleChange(e); getStateByCountryId(e.target.value) }}
                            onBlur={validation.handleBlur} invalid={validation.touched.countryId && validation.errors.countryId ? true : false}
                            touched={validation.touched.countryId} isMandatory={true} /></Col> */}
                        <Col lg={6}><CustomDropdown label="State" id="encryptedStateId" value={validation.values.encryptedStateId} data={stateMaster}
                            error={validation.values.encryptedStateId == "" ? validation.errors.encryptedStateId : null} valueField="encryptedId" displayField='displayName' onChange={(e) => { validation.handleChange(e); validation.setFieldValue("encryptedCityId", ""); validation.setFieldValue("encryptedZipId", ""); getCityByStateId(e.target.value) }}
                            onBlur={validation.handleBlur} invalid={validation.touched.encryptedStateId && validation.errors.encryptedStateId ? true : false}
                            touched={validation.touched.encryptedStateId} isMandatory={true} /></Col>

                        <Col lg={6}><CustomDropdown label="City" id="encryptedCityId" value={validation.values.encryptedCityId} data={cityMaster}
                            error={validation.values.encryptedCityId == "" ? validation.errors.encryptedCityId : null} valueField="encryptedId" displayField='displayName' onChange={(e) => { validation.handleChange(e); validation.setFieldValue("encryptedZipId", ""); getZipCodeByCityId(e.target.value) }}
                            onBlur={validation.handleBlur} invalid={validation.touched.encryptedCityId && validation.errors.encryptedCityId ? true : false}
                            touched={validation.touched.encryptedCityId} isMandatory={true} /></Col>

                        <Col lg={6}><CustomDropdown label="Zip Code" id="encryptedZipId" value={validation.values.encryptedZipId} data={zipCodeMaster}
                            error={validation.errors.encryptedZipId} valueField="encryptedId" displayField='displayName' onChange={validation.handleChange}
                            onBlur={validation.handleBlur} invalid={validation.touched.encryptedZipId && validation.errors.encryptedZipId ? true : false}
                            touched={validation.touched.encryptedZipId} isMandatory={true} /></Col>
                        {isEdit &&
                            <Col xxl={3} lg={6} >
                                <div className="mt-3 form-check form-switch"   >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="toggle"
                                        checked={isToggle}
                                        onChange={() => onToggleChange()}
                                    />
                                    <label className="form-check-label">{isToggle ? "Active" : "InActive"}</label>
                                </div>
                            </Col>}
                    </Row>
                    <div className="d-grid mt-4">
                        <button  disabled={isSubmitting} className="loginbtn" type="submit">{isEdit ? "Update" : "Submit"}</button>
                    </div>
                </Form>
            </div>
            {/* <CustomToaster message={(!isCreateMode && isEdit) ? Toaster_ENUM.edit.text : Toaster_ENUM.create.text} color={"text-success"}
                toast={(!isCreateMode && isEdit) ? toastUpdate : toastCreate}
                setToast={(!isCreateMode && isEdit) ? setToastUpdate : setToastCreate} path={""} /> */}
            <Modal isOpen={isToggleModel} toggle={onClose}>
                <ModalBody>
                    <p><b>Warning Message</b></p>
                    <p>This location is associated with one of the restaurent it can't be inactive</p>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
};

export default UniversityMaster;